module.exports = __webpack_public_path__ + "img/img8.449d24a1.png";